import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNowhitespace]'
})
export class NowhitespaceDirective {

  constructor() { }


  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if(e.keyCode == 32 || e.keyCode == 229 || e.keyCode == 62 )
    {
      e.preventDefault();
      return;
    }
    // {
    //  this.count2++;
    // }
    // if(e.keyCode == 32 && this.count2 ==1)
    // {
    //   e.preventDefault();
    //     return;
    // }
    // if (e.keyCode == 32 && this.count2) {
    //   this.count ++;
    //  if(this.count>1)
    //   {
    //     e.preventDefault();
    //     return;
    //   }
    // }
    // else{
    //   this.count =0;
    // }

  }

}
